/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_LabelInputs */

const en_svc_n8n_label = /** @type {(inputs: Svc_N8n_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n automation`)
};

const lv_svc_n8n_label = /** @type {(inputs: Svc_N8n_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n automatizācija`)
};

/**
* | output |
* | --- |
* | "n8n automation" |
*
* @param {Svc_N8n_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_label = /** @type {((inputs?: Svc_N8n_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_label(inputs)
	return en_svc_n8n_label(inputs)
});